import { Component, inject } from '@angular/core';
import { SEOService } from '../../services';
import { EventsBrowseService } from '../../events-browse/events-browse.service';
import { TranslocoModule } from '@ngneat/transloco';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.scss'],
  standalone: true,
  imports: [TranslocoModule, RouterOutlet],
})
export class EventsComponent {
  private seoService = inject(SEOService);
  private eventsBrowseService = inject(EventsBrowseService);


  constructor() {
    this.seoService.updateTitle('Événements');
    this.eventsBrowseService.organizer = undefined;
    this.eventsBrowseService.widget = false;
  }

}
